var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 p-0"
  }, [_c('div', {
    staticClass: "login-left-wrap login-otp-left-wrap"
  }, [_c('div', {
    staticClass: "back-icon text-start"
  }, [_c('router-link', {
    staticClass: "ms-0 pl-0 d-inline-block",
    attrs: {
      "to": "/login-password"
    }
  }, [_vm._v(" Back ")])], 1), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-1"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-3 pb-3"
  }, [_c('div', {
    staticClass: "email-change-wrap mb-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.email))]), _c('div', {
    staticClass: "login-highlight d-inline-block",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": "Change email address"
    },
    on: {
      "click": _vm.routeToLogin,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.routeToLogin.apply(null, arguments);
      }
    }
  }, [_vm._v(" Change ")])]), _c('form', {
    staticClass: "new-login-otp-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.verifyToken.apply(null, arguments);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        _vm.isLockedOut ? $event.preventDefault() : null;
      }
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_vm._m(1), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "otp-input-wrapper d-flex"
  }, _vm._l(_vm.digits, function (digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.digits[index],
        expression: "digits[index]"
      }],
      key: index,
      ref: "inputs",
      refInFor: true,
      staticClass: "otp-input",
      class: {
        'error-border': _vm.otpErrorFlag && !_vm.isLockedOut
      },
      attrs: {
        "type": "tel",
        "maxlength": "1",
        "inputmode": "numeric",
        "autocomplete": "one-time-code",
        "disabled": _vm.isLockedOut,
        "aria-label": `OTP digit ${index + 1}`,
        "aria-describedby": _vm.otpErrorFlag && !_vm.isLockedOut ? 'otp-error' : null
      },
      domProps: {
        "value": _vm.digits[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.digits, index, $event.target.value);
        }, function ($event) {
          return _vm.handleInput(index, $event);
        }],
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) return null;
          return _vm.handleDelete(index, $event);
        },
        "paste": function ($event) {
          $event.preventDefault();
          return _vm.handlePaste.apply(null, arguments);
        },
        "focus": _vm.clearError
      }
    });
  }), 0), _vm.otpErrorFlag && !_vm.isLockedOut ? _c('div', {
    staticClass: "valid-error mt-2",
    attrs: {
      "aria-live": "polite",
      "id": "otp-error"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e()])]), _c('button', {
    staticClass: "submit-btn mt-3 next-btn d-flex align-items-center justify-content-center",
    attrs: {
      "disabled": !_vm.isOtpComplete || _vm.formLoader || _vm.isLockedOut,
      "type": "submit"
    }
  }, [_vm.formLoader ? _c('b-spinner', {
    staticClass: "me-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.formLoader ? 'Logging in...' : 'Login'))])], 1)]), _c('div', {
    staticClass: "resend-timer-wrap"
  }, [!_vm.isLockedOut ? _c('login-otp', {
    attrs: {
      "expiry-second": 60,
      "is-loading": _vm.otpLoader
    },
    on: {
      "sendOTP": _vm.sendOTP
    }
  }) : _vm._e(), _vm.isLockedOut && _vm.lockoutSeconds > 0 ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutSeconds
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "col-lg-5 col-md-5 p-0"
  }, [_c('login-in-carsoule')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('label', {
    staticClass: "opt-label mt-0"
  }, [_vm._v(" Enter OTP"), _c('span', {
    staticClass: "required-sign"
  }, [_vm._v(" *")])])]);

}]

export { render, staticRenderFns }